import React, { Component } from 'react';
import { get,post } from '../utils/request';
// component
import Banner from '../components/banner';
import TopDom from '../components/top';
import queryString from 'query-string';
import { wxShare } from '../utils/util';

// css
import '../assets/css/success.scss';
import { UserInfoClass } from '../components/groupPerson';

class Success extends Component {
  constructor(props) {
    super(props);
    this.state = {
      endReCourse: false,
      showDefaultSuccessView: true, 
      successText: '',
      successImg: '',
    }
  }

  getPageInfo = () => {
    post('/fancube/apply/apply_info/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        this.setState({
          showDefaultSuccessView: res.data.define_sign_up.is_default_success == 1 ? true : false, // 跳转成功页面数据
          successText: res.data.define_sign_up.success.content,
          successImg: res.data.define_sign_up.success.qr_code,
        })
      }
    })
  }
  
  // get('/api/website/actives/?p=1&n=3')
  getReCourse = () => {
    post('/fancube/apply/success-recommend/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        this.setState({
          reCourse: res.data.recommends,
          endReCourse: true
        }) 
      }
    })
  }
  componentDidMount() {
    let useInfo = localStorage.getItem('formPageSto') && JSON.parse(localStorage.getItem('formPageSto'));
    if (useInfo && useInfo.banner) {
      this.setState({
        bannerUrl: useInfo.banner,
      })
    }
    if(useInfo && useInfo.title) {
      document.title = useInfo.title;
      let wxTitle = `我已报名成功，邀请你一起报名${useInfo.title}`;
      let wxDes = `我正在报名小饭桌的活动，赶紧一起报名吧~`;
      let wxUrl = useInfo.shareUrl;
      wxShare(wxTitle, wxDes, wxUrl);
    }

    const urlValues = queryString.parse(this.props.location.search);
    this.pageUrlValues = urlValues;

    this.getPageInfo();
    this.getReCourse();
  }
  render () {
    return (
      <div className="success-wrapper page-wrapper">
        <TopDom />
        <Banner url={this.state.bannerUrl}/>
        <div className="submit-success need-clear">
          <p className="success">提交成功！</p>
          <div className="subscribe">
              <div style={{'padding': '20px 30px'}}> 
                <div className="subscribe-title sub-ti-fa" > 我们已经收到您提交的资料，工作人员会在5个工作日内与您取得联系。 </div>
                <div className="subscribe-title sub-ti-fa" > 如需补充提交BP，添加工作人员微信，备注“姓名-BP”提交BP。</div>
                <div className="subscribe-title sub-ti-fa" > 如有疑问，请联系小饭桌工作人员，手机同微信号：13810700473。</div>
              </div>
          </div>
        </div>
        <div className="height-100"></div>
        <div className="height-100"></div>
      </div>
    );
  }
}

export default Success;